export default __webpack_public_path__ + "static/9-c72cd61884cc256fc20654205a688896.png";